<div class="section-header">
    <div class="section-header" bdFxLayoutAlign="space-between center">
        <div class="title" bdFxFlex>
            Bezugsinformationen
        </div>
    </div>
</div>


<div>

    <app-labeled-select-distributor-input label="Bezug über*" placeholder="Bitte auswählen"
                             [ngClass]="{'notify-change' : notifyChange( pUNFEnum.PRODUCT_DISTRIBUTOR ) }"
                             required
                             [appInvalidValueList]="getInactiveProductDistributorIdsList()"
                             [values]="getProductDistributorValues()"
                             [choices]="getProductDistributorChoices()"
                             [forceFormValidationVisibility]="forceFormValidationVisibility"
                             name="productDistributor"
                             [(ngModel)]="model.project.requestedProductInfo.productDistributorId"
                                          (ngModelChange)="onProductDistributorChanged(model.project.requestedProductInfo)"
                             #productDistributorNgModel="ngModel">
    </app-labeled-select-distributor-input>
    <bd-input-error-viewer [ngModelRef]="productDistributorNgModel"
                           [customErrorsMsg]="{invalidValue:'Kann nicht inaktiv sein, bitte wählen Sie einen anderen Wert'}">
    </bd-input-error-viewer>


    <app-labeled-select-distributor-input label="Bezug alternativ über" placeholder="Optional auswählen"
                                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SECONDARY_PRODUCT_DISTRIBUTOR ) }"
                                          [appInvalidValueList]="getInactiveProductDistributorIdsList()"
                                          [values]="getSecondaryProductDistributorValues()"
                                          [choices]="getSecondaryProductDistributorChoices()"
                                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                                          name="secondaryProductDistributor"
                                          [disabled]="!model.project.requestedProductInfo.productDistributorId"
                                          [(ngModel)]="model.project.requestedProductInfo.secondaryProductDistributorId"
                                          (ngModelChange)="onSecondaryProductDistributorChanged(model.project.requestedProductInfo, secondaryProductDistributorNgModel)"
                                          [appNotSameValueAs]="productDistributorNgModel.value"
                                          #secondaryProductDistributorNgModel="ngModel">
    </app-labeled-select-distributor-input>
    <bd-input-error-viewer [ngModelRef]="secondaryProductDistributorNgModel"
                           [customErrorsMsg]="{invalidValue:'Kann nicht inaktiv sein, bitte wählen Sie einen anderen Wert',
                           appNotSameValueAs: 'Bitte Alternative zum ersten Bezug auswählen'}">
    </bd-input-error-viewer>



    <app-info-icon-button
        [model]="{ title: 'Information',
                   messages: ['Bitte geben Sie ein, wann mit der Auslieferung der ersten Produkte begonnen werden soll.'],
                   dialogHeight: 100}">
    </app-info-icon-button>
    <bd-labeled-date-input label="Auslieferungsbeginn*"
                           [ngClass]="{'notify-change' : notifyChange( pUNFEnum.PRODUCT_ROLLOUT_START ) } "
                           required
                           [forceFormValidationVisibility]="forceFormValidationVisibility"
                           name="rolloutStart" [(ngModel)]="model.project.requestedProductInfo.rolloutStart"
                           [datePickerMinDate]="getRolloutStartMinDay()"
                           [datePickerMaxDate]="editModalService.getNext5YearsDate()"
                           [datePickerDaysDisabled]="[6,0]"
                           [bdMinDate]="getRolloutStartMinDay()"
                           [bdMaxDate]="editModalService.getNext5YearsDate()"
                           appWorkingDay
                           #rolloutStartNgModel="ngModel"
                           (ngModelChange)="onRolloutStartChanged( rolloutEndNgModel )">
    </bd-labeled-date-input>
    <bd-input-error-viewer [ngModelRef]="rolloutStartNgModel">
    </bd-input-error-viewer>
    <div class="one-shot">
        <div>
            <bd-checkbox-squared name="isOneshot"
                                 [(ngModel)]="model.project.requestedProductInfo.isOneshot"
                                 (ngModelChange)="setRollOutEnd()"
                                 #oneShotNgModel="ngModel">
            </bd-checkbox-squared>
        </div>

        <div>Oneshot</div>

    </div>


    <app-info-icon-button
        [model]="{ title: 'Information',
                   messages: ['Bitte geben Sie ein, wann die Auslieferung abgeschlossen werden soll.'],
                   dialogHeight: 100}">
    </app-info-icon-button>
    <bd-labeled-date-input label="Auslieferungsende*"
                           [disabled]="model.project.requestedProductInfo.isOneshot"
                           [ngClass]="{'notify-change' : notifyChange( pUNFEnum.PRODUCT_ROLLOUT_END) } "
                           required
                           [forceFormValidationVisibility]="forceFormValidationVisibility"
                           name="rolloutEnd" [(ngModel)]="model.project.requestedProductInfo.rolloutEnd"
                           [datePickerMinDate]="getRolloutEndMinDate(model.project.requestedProductInfo.rolloutStart)"
                           [datePickerMaxDate]="editModalService.getNext5YearsDate()"
                           [datePickerDaysDisabled]="[6,0]"
                           [bdMinDate]="getRolloutEndMinDate(model.project.requestedProductInfo.rolloutStart)"
                           [bdMaxDate]="editModalService.getNext5YearsDate()"
                           appWorkingDay
                           #rolloutEndNgModel="ngModel">
    </bd-labeled-date-input>
    <bd-input-error-viewer [ngModelRef]="rolloutEndNgModel"
                           [customErrorsMsg]="{'isBdMinDate':'Auslieferungsende muss nach Auslieferungsbeginn liegen'}">
    </bd-input-error-viewer>

    <div class="space-for-datepicker"></div>

</div>


